import React from 'react'

import { P } from '@mxenabled/mxui'

import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'

interface RightBoxProps {
  isComplete?: boolean
  rightLowerText: string
  rightUpperText: string
}

export const RightBox: React.FC<RightBoxProps> = ({
  isComplete,
  rightLowerText,
  rightUpperText,
}) => {
  return (
    <Box
      sx={{
        bgcolor: isComplete ? 'success.lighter' : 'transparent',
        border: isComplete ? '1px solid' : '1px dashed',
        borderColor: isComplete ? 'success.darker' : 'secondary.lighter',
        borderRadius: '4px',
        p: 12,
        width: '100%',
      }}
    >
      <Stack alignItems="center" gap={2} justifyContent="center">
        <P
          data-ui-test="mx-insights-sudd-right-upper-text"
          sx={{
            color: isComplete ? 'common.black' : 'secondary.light',
          }}
          variant="caption"
        >
          {rightUpperText}
        </P>
        <P
          bold={true}
          data-ui-test="mx-insights-sudd-right-lower-text"
          sx={{
            bgcolor: isComplete ? 'success.darker' : 'warning.lighter',
            borderRadius: 4,
            color: isComplete ? 'common.white' : 'warning.darker',
            fontSize: 10,
            p: '2px 8px',
          }}
          variant="tiny"
        >
          {rightLowerText}
        </P>
      </Stack>
    </Box>
  )
}
